import {
  ADMINDRAWER_OPEN,
  ADMINDRAWER_CLOSE,
  APP_DRAWER_TOGGLE
} from "types/actions/drawers"

const drawerInitialState = {
  adminDrawer: false,
  appDrawer: false
}

export default (state = drawerInitialState, action) => {
  switch (action.type) {
    case ADMINDRAWER_OPEN:
    case ADMINDRAWER_CLOSE:
      const rest = action
      delete rest.type
      return {
        ...state,
        ...rest
      }
    case APP_DRAWER_TOGGLE:
      return {
        ...state,
        appDrawer: !state.appDrawer
      }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/drawers.js